<a
  class="pill-btn"
  [class]="'pill-btn--' + variant()"
  [href]="href()"
  [attr.target]="external() ? '_blank' : null"
  [attr.rel]="external() ? 'noopener noreferrer' : null"
>
  <span class="pill-btn__label">{{ label() }}</span>
  <span class="pill-btn__shine" aria-hidden="true"></span>
</a>
